<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Client ID:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Phone No.:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Security Type:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.securityTypeName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Security Name:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.theSecurityName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Security Location:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.securityLocation }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Loan Amount Taken:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanAmountTaken | number }}
        </span>
      </div>
    </div>
  </div>
</div>
